import { Page, PageGameVersion, PageHeadline, PageHeadlineSize, PageSeparator } from "@spawn/modern-ui";
import { GamblingSection, RulesSection } from "@spawn/page-components";
import * as React from "react";
import { IPageHelpersFactory } from "./pageHelpers";

/** Creates the help page of a game. `titleKey` is the translation key of the game title. */
export const createHelpPage = ({ usePageHelpers }: IPageHelpersFactory, titleKey: string): (() => JSX.Element) => {
	const HelpPage = (): JSX.Element => {
		const {
			services: { i18n },
			components: { Headline, TextWithImages, Text },
		} = usePageHelpers();

		return (
			<Page testId="help">
				<PageHeadline testId={titleKey} text={i18n.t(titleKey)} size={PageHeadlineSize.H1} />
				<Headline testId="helppage.game" />
				<Text testId="helppage.reels" params={{ amount: "5" }} />
				<Text testId="helppage.lines" params={{ amount: "20" }} />

				<Headline testId="nudgenreveal.headline" />
				<TextWithImages testId="nudgenreveal.text1" params={{ symbolId: "[reveal]" }} />
				<TextWithImages testId="nudgenreveal.text2" params={{ symbolId1: "[reveal]", symbolId2: "[golden_bonus]" }} />
				<TextWithImages testId="nudgenreveal.text3" params={{ symbolId: "[reveal]" }} />
				<Text testId="general.changebetwarning" />

				<Headline testId="nudgenreveal.headline2" />
				<TextWithImages
					testId="nudgenreveal.text10"
					params={{
						symbolId: "[golden_bonus]",
						symbollist: "[bonus_s], [bonus_m], [bonus_l], [bonus_xl], [scatter_fg]",
					}}
				/>

				<Headline testId="nudgenreveal.text4" />
				<Text testId="nudgenreveal.text11" />

				<Headline testId="wild.title" />
				<TextWithImages testId="wild.exceptScatterAndBonus" params={{ symbolId: "[top]" }} />

				<Headline testId="general.freegames" />
				<TextWithImages testId="scatter.isScatter" params={{ symbolId: "[scatter_bg]" }} />
				<TextWithImages testId="freegames.trigger3" params={{ scatterCount: "3", symbolId: "[scatter_bg]" }} />
				<TextWithImages testId="nudgenreveal.fg.extraScatter" params={{ symbolId: "[reveal]" }} />
				<TextWithImages testId="nudgenreveal.text5" params={{ symbolId: "[reveal]" }} />
				<TextWithImages testId="nudgenreveal.text6" params={{ symbolId1: "[scatter_fg]", symbolId2: "[reveal]" }} />
				<Text testId="nudgenreveal.text7" params={{ amount: "1" }} />
				<Text testId="nudgenreveal.text8" />

				<PageSeparator />

				<GamblingSection />

				<RulesSection hasFreegames={true} hasScatter={true} hasGoldenBonus={true} maxTotalWin={50000} />

				<PageSeparator />

				<PageGameVersion />
			</Page>
		);
	};
	return HelpPage;
};
